export const GROUP_MANAGE_STUDENTS_ROUTE_NAME = "school.group.add-student";
export const GROUP_MANAGE_TEACHERS_ROUTE_NAME = "school.class.register-teacher-class";
export const HOME_ROUTE_NAME = "school.home";
export const STUDENT_ROUTE_NAME = "school.student.index";
export const BOOKS_AND_CARDS_ROUTE_NAME = "school.books.and.cards.index";
export const PAGE_NOT_FOUND = "page.not.found";
export const LOGIN_ROUTE_NAME = "login";

export const EMPLOYEE_ROUTES = [
  HOME_ROUTE_NAME,
  PAGE_NOT_FOUND,
  STUDENT_ROUTE_NAME,
  BOOKS_AND_CARDS_ROUTE_NAME
]

export const MANAGER_ROUTES = [
  ...EMPLOYEE_ROUTES,
];

export const TEACHER_ROUTES = [
  ...EMPLOYEE_ROUTES
];






